export enum UserProductType {
  Desks = "DESKS",
  Workforce = "WORKFORCE",
}

export enum ProductType {
  Desks = "DESKS",
  Workforce = "WORKFORCE",
  Visitors = "VISITORS",
}

export const ProductNameLabels: Record<ProductType, string> = {
  [ProductType.Desks]: "Desks",
  [ProductType.Workforce]: "Workforce",
  [ProductType.Visitors]: "Visitors",
};
